import { Suspense, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

// project-imports
import Loader from 'components/Loader';
import useConfig from 'hooks/useConfig';
import { setResolvedTheme } from 'components/setResolvedTheme';

// ==============================|| LAYOUT - AUTH ||============================== //

export default function AuthLayout(): React.ReactElement {
  const { themeDirection, customColor, mode } = useConfig();

  useEffect(() => {
    document.body.setAttribute('data-pc-preset', customColor);
    document.body.setAttribute('data-pc-direction', themeDirection);
    document.body.setAttribute('data-pc-theme', mode);
    setResolvedTheme(mode);
  }, [customColor, themeDirection, mode]);

  return (
    <Suspense fallback={<Loader />}>
      <Outlet />
    </Suspense>
  );
}
